import React, { createRef } from 'react';
import { MessageButtonModalProps } from './types';

export function MessageButtonModal(props: MessageButtonModalProps) {
  const backdropRef = createRef<HTMLDivElement>();

  if (!props.showModal) {
    return null;
  }

  function handleBackdropClick(event) {
    if (!props.handleCloseModal) {
      return;
    }

    if (event.target !== backdropRef.current) {
      return;
    }

    event.stopPropagation();
    props.handleCloseModal();
  }

  return (
    <>
      <div
        className="modal centered-modal component-modal fade show"
        ref={backdropRef}
        onClick={handleBackdropClick}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            {props.title && <h3 className="modal-title center-align">{props.title}</h3>}

            {props.messageIsHtml ? (
              <div
                className="modal-message center-align"
                dangerouslySetInnerHTML={{ __html: props.message }}
              />
            ) : (
              <p className="modal-message center-align">{props.message}</p>
            )}

            <div className="btn btn-primary" onClick={() => props.handleButtonClick()}>
              {props.buttonText}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
